module.exports = __webpack_public_path__ + "img/UrbanMining.d5c0f17.jpg";